import { redirect } from "@sveltejs/kit";
import type { LayoutLoad } from "./$types";
import { supabase } from "@/shared/api/supabaseClient";
import getProfile from "@/entities/user/api/getProfile";

export const ssr = false;

const ONBOARDING_EXEMPT = ["/onboarding", "/login", "/invite"];

export const load: LayoutLoad = async ({ depends, url }) => {
  depends("supabase:auth");

  const { data } = await supabase.auth.getSession();

  const profile = data.session ? await getProfile(data.session.user.id) : null;

  if (
    data.session &&
    !profile &&
    !ONBOARDING_EXEMPT.some((path) => url.pathname.startsWith(path))
  ) {
    throw redirect(302, "/onboarding?redirectTo=tables");
  }

  return { session: data.session, profile };
};
